var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentAccountMenu,{tag:"component",attrs:{"mode":"horizontal","default-active":_vm.activeItem,"background-color":"transparent","text-color":"#555555","active-text-color":"#ffffff","router":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }